import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { Store, Select } from '@ngxs/store';
import { LastChapter, RemoveChapter, TakeChapterPicture, DuplicateChapter, RecordChapterCamera } from 'src/app/story/state/chapters/story.chapters.actions';
import { MatSnackBar, MatDialog } from '@angular/material';
import { CameraService } from 'src/app/engine/camera.service';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable } from 'rxjs';
import { ContentDialogComponent } from '../content-dialog/content-dialog.component';
import { StoryChapterThumbnail } from 'src/app/story/models/story-chapter-thumbnail.model';
import { DialogService } from 'src/app/dialogs/dialog.service';
import { BackgroundModel } from 'src/app/engine/models/background.model';

@Component({
  selector: 'app-chapter-actions',
  templateUrl: './chapter-actions.component.html',
  styleUrls: ['./chapter-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChapterActionsComponent implements OnInit {
  @Select(StoryChaptersState.getStoryChapters)
  chapters$: Observable<ChapterModel[]>;

  @Select(StoryChaptersState.getRegisteredThumbnails)
  thumbnails$: Observable<Map<string, StoryChapterThumbnail>>;

  @Select(StoryChaptersState.getSelectedChapterBackground)
  background$: Observable<BackgroundModel>;

  @Input()
  chapter: ChapterModel;

  @Input()
  selected = false;

  constructor(
    private store: Store,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private cameraService: CameraService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
  }

  handleCaptureClick() {
    this.capturePosition();
    this.captureThumbnail();
    this.snackbar.open('Successfully captured chapter starting position and thumbnail.');
  }

  handleCapturePositionClick() {
    this.capturePosition();
    this.snackbar.open('Successfully captured chapter starting position.');
  }

  handleCaptureThumbnailClick() {
    this.captureThumbnail();
    this.snackbar.open('Successfully captured chapter thumbnail.');
  }
  
  handleDuplicateClick() {
    this.duplicateChapter();
  }

  handleRemoveClick() {
    this.removeChapter();
  }

  handleContentClick() {
    this.openChapterContentDialog(this.chapter.id);
  }

  handleBackgroundColorClick() {
    this.dialogService.openBackgroundColorDialog();
  }

  duplicateChapter() {
    this.store.dispatch(new DuplicateChapter(this.chapter));
    this.snackbar.open(`Duplicated chapter "${this.chapter.info.displayName}"`);
  }

  removeChapter() {
    const dialogRef = this.dialogService.openConfirmDialog({
      data: {
        titleText: 'Remove chapter',
        bodyText: 'This cannot be undone.',
        confirmText: 'Remove',
        confirmColor: 'warn'
      }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.store.dispatch(new RemoveChapter(this.chapter));
        this.snackbar.open(`"${this.chapter.info.displayName}" chapter has been removed`);
      }
    });
  }

  captureThumbnail() {
    this.store.dispatch(new TakeChapterPicture(this.chapter.id));
  }

  capturePosition() {
    const camera = this.cameraService.getCamera();
    this.store.dispatch(new RecordChapterCamera(camera, true));
  }

  openChapterContentDialog(chapterId: string) {
    this.dialog.open(ContentDialogComponent, {
      width: '60vw',
      height: 'auto',
      data: {
        chapterId: chapterId
      }
    });
  }
}
